// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconOpenEye = (props: IconType) => {
  const {
    size,
    inverse,
    onClick,
    width,
    height,
    fill,
    iconClassName,
  } = props;

  const defaultMeasurements: Measurements = {
    height: 16,
    width: 24,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-open-eye">
      <svg
        className="c-icon-open-eye fill-current"
        width={width || measurements.width}
        height={height || measurements.height}
        viewBox="0 0 24 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 15.7625C4.57502 15.7625 0.900024 8.675 0.750024 8.375C0.637524 8.15 0.637524 7.85 0.750024 7.625C0.900024 7.325 4.57502 0.275024 12 0.275024C19.425 0.275024 23.1 7.325 23.25 7.625C23.3625 7.85 23.3625 8.15 23.25 8.375C23.1 8.675 19.425 15.7625 12 15.7625ZM2.47502 8C3.30002 9.3875 6.52502 14.075 12 14.075C17.475 14.075 20.7 9.3875 21.525 8C20.7 6.6125 17.475 1.92502 12 1.92502C6.52502 1.92502 3.30002 6.6125 2.47502 8Z" fill={fill || 'inherit'} />
        <path d="M12 11.1875C10.2375 11.1875 8.8125 9.7625 8.8125 8C8.8125 6.2375 10.2375 4.8125 12 4.8125C13.7625 4.8125 15.1875 6.2375 15.1875 8C15.1875 9.7625 13.7625 11.1875 12 11.1875ZM12 6.5C11.175 6.5 10.5 7.175 10.5 8C10.5 8.825 11.175 9.5 12 9.5C12.825 9.5 13.5 8.825 13.5 8C13.5 7.175 12.825 6.5 12 6.5Z" fill={fill || 'inherit'} />
      </svg>
    </Icon>
  );
};

export default IconOpenEye;
